var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiveStars = function SvgFiveStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA00",
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21zM36 17.27 42.18 21l-1.64-7.03L46 9.24l-7.19-.61L36 2l-2.81 6.63-7.19.61 5.46 4.73L29.82 21zM61 17.27 67.18 21l-1.64-7.03L71 9.24l-7.19-.61L61 2l-2.81 6.63-7.19.61 5.46 4.73L54.82 21zM85 17.27 91.18 21l-1.64-7.03L95 9.24l-7.19-.61L85 2l-2.81 6.63-7.19.61 5.46 4.73L78.82 21zM110 17.27l6.18 3.73-1.64-7.03L120 9.24l-7.19-.61L110 2l-2.81 6.63-7.19.61 5.46 4.73-1.64 7.03z"
  })));
};
export { SvgFiveStars as ReactComponent };
export default "/_next/static/media/src/global/pageComponents/HeroBanner/assets/five-stars.9b6b503fa1e4f2464f47c76614a01d29.svg";